import React, { useState } from 'react';
import './English.css';

const topics = {
    
      "Alphabet Sounds-A for apple": {
        definition: "Alphabet sounds help children connect letters to their corresponding sounds.",
        details: "For example, the letter 'A' makes the sound /æ/ as in 'apple.' Learning alphabet sounds is a fundamental step in developing reading and spelling skills.",
        examples: [
          "Example 1: A for apple. 'Apple' starts with the sound /æ/.",
          "Example 2: A for ant. 'Ant' also starts with the sound /æ/."
        ],
        problem: {
          question: "Identify the sound the letter 'A' makes in the word 'apple'.",
          solution: "The letter 'A' makes the sound /æ/ in the word 'apple.'"
        }
      },
      "Alphabet Sounds-B for ball": {
        definition: "Alphabet sounds help children connect letters to their corresponding sounds.",
        details: "For example, the letter 'B' makes the sound /b/ as in 'ball.' Learning alphabet sounds is essential for phonics and early literacy.",
        examples: [
          "Example 1: B for ball. 'Ball' starts with the sound /b/.",
          "Example 2: B for bat. 'Bat' also starts with the sound /b/."
        ],
        problem: {
          question: "Identify the sound the letter 'B' makes in the word 'ball'.",
          solution: "The letter 'B' makes the sound /b/ in the word 'ball.'"
        }
      },
      "Alphabet Sounds-C for cat": {
        definition: "Alphabet sounds help children connect letters to their corresponding sounds.",
        details: "For example, the letter 'C' can make the sound /k/ as in 'cat' or /s/ as in 'city.' Learning alphabet sounds helps children decode words.",
        examples: [
          "Example 1: C for cat. 'Cat' starts with the sound /k/.",
          "Example 2: C for cake. 'Cake' also starts with the sound /k/."
        ],
        problem: {
          question: "Identify the sound the letter 'C' makes in the word 'cat'.",
          solution: "The letter 'C' makes the sound /k/ in the word 'cat.'"
        }
      },
    
    "CVC Words (Consonant-Vowel-Consonant)": {
      definition: "CVC words are simple three-letter words that follow a consonant-vowel-consonant pattern.",
      details: "CVC words are often the first words children learn to read as they have a simple and predictable structure.",
      examples: [
        "Example 1: cat. 'Cat' is a CVC word with the consonants 'c' and 't' and the vowel 'a'.",
        "Example 2: dog. 'Dog' is a CVC word with the consonants 'd' and 'g' and the vowel 'o'."
      ],
      problem: {
        question: "Identify the CVC word in the sentence: 'The dog is playing.'",
        solution: "The CVC word is 'dog.'"
      }
    },
    "Blends": {
      definition: "Blends are groups of two or more consonants whose sounds blend together but each sound can still be heard.",
      details: "Blends help create more complex sounds and are often found at the beginning or end of words.",
      examples: [
        "Example 1: bl (blue). 'Bl' is a blend where the sounds of 'b' and 'l' blend together in 'blue'.",
        "Example 2: fl (flower). 'Fl' is a blend where the sounds of 'f' and 'l' blend together in 'flower'."
      ],
      problem: {
        question: "Identify the blend in the word 'clap'.",
        solution: "The blend in the word 'clap' is 'cl.'"
      }
    },
    "Digraphs": {
      definition: "Digraphs are pairs of letters that create a single sound when combined.",
      details: "Common digraphs include 'ch,' 'sh,' 'th,' and 'wh.' They are important for building phonemic awareness.",
      examples: [
        "Example 1: ch (chair). 'Ch' is a digraph that creates a single sound in 'chair'.",
        "Example 2: sh (ship). 'Sh' is a digraph that creates a single sound in 'ship'."
      ],
      problem: {
        question: "Identify the digraph in the word 'this'.",
        solution: "The digraph in the word 'this' is 'th.'"
      }
    },
    "Long Vowel Sounds": {
      definition: "Long vowel sounds occur when the vowel says its name.",
      details: "Long vowel sounds can be created by a silent 'e' at the end of a word or by vowel pairs like 'ai,' 'ee,' and 'oa.'",
      examples: [
        "Example 1: cake. The 'a' in 'cake' is a long vowel sound due to the silent 'e' at the end.",
        "Example 2: bike. The 'i' in 'bike' is a long vowel sound due to the silent 'e' at the end."
      ],
      problem: {
        question: "Identify the long vowel sound in the word 'home'.",
        solution: "The long vowel sound in the word 'home' is 'o.'"
      }
    },
  

    "Common Nouns": {
      definition: "Common nouns are general names for a person, place, thing, or idea. They are not specific and are not capitalized unless they begin a sentence.",
      details: "Common nouns can refer to any member of a group, such as 'dog,' 'cat,' 'house,' etc. They are different from proper nouns, which name specific people, places, or things and are always capitalized.",
      examples: [
        "Example 1: A dog is a common noun. 'Dog' can refer to any dog, not a specific one.",
        "Example 2: A house is a common noun. 'House' can refer to any house, not a specific one."
      ],
      problem: {
        question: "Identify the common nouns in the sentence: 'The cat is sleeping on the tree near the car.'",
        solution: "The common nouns are 'cat,' 'tree,' and 'car.' Each of these words refers to a general item, not a specific one."
      }
    },
    "Action Verbs": {
      definition: "Action verbs express physical or mental actions. They show what someone or something is doing.",
      details: "Action verbs can describe activities such as running, jumping, eating, sleeping, and thinking. They are essential in sentences to convey what the subject is doing.",
      examples: [
        "Example 1: She can run fast. 'Run' is an action verb because it describes what she is doing.",
        "Example 2: He likes to read books. 'Read' is an action verb because it describes the action he enjoys doing."
      ],
      problem: {
        question: "Identify the action verbs in the sentence: 'The kids play outside and jump around.'",
        solution: "The action verbs are 'play' and 'jump.' These verbs describe the actions that the kids are performing."
      }
    },
    "Adjectives": {
      definition: "Adjectives describe or modify nouns. They provide more information about a noun's size, shape, color, etc.",
      details: "Adjectives can describe various attributes of a noun, such as 'big,' 'small,' 'happy,' 'sad,' 'fast,' and 'slow.' They help add detail and specificity to sentences.",
      examples: [
        "Example 1: The big dog barked loudly. 'Big' is an adjective that describes the size of the dog.",
        "Example 2: She wore a small dress. 'Small' is an adjective that describes the size of the dress."
      ],
      problem: {
        question: "Identify the adjectives in the sentence: 'He is a happy child with a fast car.'",
        solution: "The adjectives are 'happy' and 'fast.' 'Happy' describes the child, and 'fast' describes the car."
      }
    },
    "Colors": {
      definition: "Colors are used to describe the hues seen by the human eye. They can be primary, secondary, or tertiary colors.",
      details: "Colors can describe various hues such as 'red,' 'blue,' 'green,' 'yellow,' 'orange,' and 'purple.' They are used to describe the appearance of objects.",
      examples: [
        "Example 1: The apple is red. 'Red' is a color describing the hue of the apple.",
        "Example 2: She painted the room blue. 'Blue' is a color describing the hue of the room."
      ],
      problem: {
        question: "Identify the colors in the sentence: 'The rainbow has red, blue, and green stripes.'",
        solution: "The colors are 'red,' 'blue,' and 'green.' These words describe the hues of the stripes in the rainbow."
      }
    },
    "Numbers": {
      definition: "Numbers are symbols used to represent quantities. They can be used in counting, measuring, and labeling.",
      details: "Numbers can describe quantities such as 'one,' 'two,' 'three,' 'four,' 'five,' and 'six.' They help quantify and measure objects and concepts.",
      examples: [
        "Example 1: There is one apple. 'One' is a number representing the quantity of apples.",
        "Example 2: She has three cats. 'Three' is a number representing the quantity of cats."
      ],
      problem: {
        question: "Identify the numbers in the sentence: 'He has two apples and four oranges.'",
        solution: "The numbers are 'two' and 'four.' These words represent the quantities of apples and oranges."
      }
    },
    "Days of the Week": {
      definition: "Days of the week refer to the seven-day cycle in a week, starting from Monday to Sunday.",
      details: "The days of the week are 'Monday,' 'Tuesday,' 'Wednesday,' 'Thursday,' 'Friday,' 'Saturday,' and 'Sunday.' They are used to organize our schedules and routines.",
      examples: [
        "Example 1: Monday is the first day of the workweek. It is followed by Tuesday.",
        "Example 2: Sunday is a day to relax. It is the last day of the week."
      ],
      problem: {
        question: "List the days of the week in order.",
        solution: "Monday, Tuesday, Wednesday, Thursday, Friday, Saturday, Sunday. These are the seven days of the week in order."
      }
    },
    "Family Members": {
      definition: "Family members are individuals related by blood, marriage, or adoption. They include parents, siblings, grandparents, and other relatives.",
      details: "Family members can include 'mom,' 'dad,' 'brother,' 'sister,' 'grandmother,' and 'grandfather.' These terms refer to specific relationships within a family.",
      examples: [
        "Example 1: My mom is very kind. 'Mom' is a common term for mother, a family member.",
        "Example 2: His brother is a good soccer player. 'Brother' is a term for a male sibling, a family member."
      ],
      problem: {
        question: "Identify the family members in the sentence: 'Her dad and grandmother are visiting today.'",
        solution: "The family members are 'dad' and 'grandmother.' These terms refer to specific family members."
      }
    },
  
    
        "Simple Sentences": {
          
            definition: "A simple sentence structure where the subject performs an action.",
            details: "In this structure, the subject comes first, followed by the verb. It expresses a complete thought.",
            examples: [
              "Example 1: The dog runs. 'The dog' is the subject, and 'runs' is the verb.",
              "Example 2: Birds fly. 'Birds' is the subject, and 'fly' is the verb."
            ],
            problem: {
              question: "Create a simple sentence with the structure 'Subject + Verb'.",
              solution: "The cat sleeps. 'The cat' is the subject, and 'sleeps' is the verb."
            }
          },
          "Subject + Verb + Object": {
            definition: "A simple sentence structure where the subject performs an action on an object.",
            details: "In this structure, the subject comes first, followed by the verb and then the object. The object receives the action.",
            examples: [
              "Example 1: She eats an apple. 'She' is the subject, 'eats' is the verb, and 'an apple' is the object.",
              "Example 2: He reads a book. 'He' is the subject, 'reads' is the verb, and 'a book' is the object."
            ],
            problem: {
              question: "Create a simple sentence with the structure 'Subject + Verb + Object'.",
              solution: "They play soccer. 'They' is the subject, 'play' is the verb, and 'soccer' is the object."
            }
          },
        
        
          "Yes/No Questions": {
            definition: "Questions that can be answered with a 'yes' or 'no'.",
            details: "These questions often start with auxiliary verbs like 'is,' 'are,' 'do,' or 'does.'",
            examples: [
              "Example 1: Is it raining? 'Is' is the auxiliary verb, and 'it raining' is the subject and verb.",
              "Example 2: Are you coming? 'Are' is the auxiliary verb, and 'you coming' is the subject and verb."
            ],
            problem: {
              question: "Form a yes/no question with the verb 'to be'.",
              solution: "Are they ready? 'Are' is the auxiliary verb, and 'they ready' is the subject and verb."
            }
          },
          "Wh- Questions": {
            definition: "Questions that start with 'wh-' words like 'what,' 'where,' 'when,' 'who,' and 'why'.",
            details: "These questions seek information beyond a 'yes' or 'no' response.",
            examples: [
              "Example 1: What is your name? 'What' is the wh- word asking for information.",
              "Example 2: Where do you live? 'Where' is the wh- word asking for location information."
            ],
            problem: {
              question: "Form a wh- question using 'why'.",
              solution: "Why are you late? 'Why' is the wh- word asking for a reason."
            }
          },
        
        "Prepositions": {
          definition: "Words used to show the relationship of a noun or pronoun to another word.",
          details: "Prepositions can indicate location, direction, time, and other relationships between words.",
          examples: [
            "Example 1: The book is on the table. 'On' is a preposition indicating location.",
            "Example 2: She is sitting between the chairs. 'Between' is a preposition indicating position."
          ],
          problem: {
            question: "Identify the preposition in the sentence: 'The cat is under the table.'",
            solution: "The preposition is 'under.'"
          }
        },
        "Pronouns": {
          definition: "Words used in place of nouns to avoid repetition.",
          details: "Pronouns include words like 'I,' 'you,' 'he,' 'she,' 'it,' 'we,' and 'they.' They can refer to people, animals, things, or ideas previously mentioned.",
          examples: [
            "Example 1: I am happy. 'I' is a pronoun replacing the speaker's name.",
            "Example 2: She likes to read. 'She' is a pronoun replacing a girl's name."
          ],
          problem: {
            question: "Replace the noun with a pronoun: 'John is tall.'",
            solution: "'He is tall.' 'He' is the pronoun replacing 'John.'"
          }
        },
        "Articles": {
          definition: "Words that define a noun as specific or unspecific.",
          details: "Articles include 'a,' 'an,' and 'the.' 'A' and 'an' are indefinite articles, while 'the' is a definite article.",
          examples: [
            "Example 1: I saw a dog. 'A' is an indefinite article referring to any dog.",
            "Example 2: She read the book. 'The' is a definite article referring to a specific book."
          ],
          problem: {
            question: "Choose the correct article: 'I need ___ umbrella.'",
            solution: "'I need an umbrella.' 'An' is used before words that start with a vowel sound."
          }
        },
        "Conjunctions": {
          definition: "Words used to connect words, phrases, or clauses.",
          details: "Conjunctions include 'and,' 'but,' 'or,' 'because,' and 'so.' They help form more complex sentences.",
          examples: [
            "Example 1: I like apples and oranges. 'And' is a conjunction connecting two nouns.",
            "Example 2: She is tired but happy. 'But' is a conjunction connecting two adjectives."
          ],
          problem: {
            question: "Combine the sentences using 'because': 'She is hungry. She didn't eat breakfast.'",
            solution: "'She is hungry because she didn't eat breakfast.'"
          }
        },
        
          "Present Simple": {
            definition: "Describes actions happening now or regularly.",
            details: "The present simple tense uses the base form of the verb. For example, 'play,' 'run,' 'eat.'",
            examples: [
              "Example 1: I play. 'Play' is the base form of the verb indicating a regular action.",
              "Example 2: He runs every day. 'Runs' is the base form with an 's' for the third person singular."
            ],
            problem: {
              question: "Form a present simple sentence with the verb 'to eat'.",
              solution: "She eats breakfast. 'Eats' is the present simple form of the verb 'to eat' for the third person singular."
            }
          },
          "Past Simple": {
            definition: "Describes actions that happened in the past.",
            details: "The past simple tense uses the past form of the verb. For example, 'played,' 'ran,' 'ate.'",
            examples: [
              "Example 1: I played. 'Played' is the past form of the verb 'play' indicating a past action.",
              "Example 2: He ran yesterday. 'Ran' is the past form of the verb 'run' indicating a past action."
            ],
            problem: {
              question: "Form a past simple sentence with the verb 'to read'.",
              solution: "He read the book. 'Read' is the past simple form of the verb 'to read.'"
            }
          },
          "Future Simple": {
            definition: "Describes actions that will happen in the future.",
            details: "The future simple tense uses 'will' followed by the base form of the verb. For example, 'will play,' 'will run,' 'will eat.'",
            examples: [
              "Example 1: I will play. 'Will play' indicates a future action.",
              "Example 2: She will eat dinner. 'Will eat' indicates a future action."
            ],
            problem: {
              question: "Form a future simple sentence with the verb 'to travel'.",
              solution: "They will travel tomorrow. 'Will travel' indicates a future action."
            }

          },
        
         
            
              "Sight Words-Basic": {
                definition: "Sight words are commonly used words that children are encouraged to recognize without having to sound them out.",
                details: "Basic sight words include simple, frequently used words that are essential for reading fluency.",
                examples: [
                  "Example 1: I. 'I' is a basic sight word used as a pronoun.",
                  "Example 2: The. 'The' is a basic sight word used as a definite article."
                ],
                problem: {
                  question: "Identify the sight words in the sentence: 'I went to the park.'",
                  solution: "The sight words are 'I,' 'to,' and 'the.'"
                }
              },
              "Sight Words-Common": {
                definition: "Common sight words are frequently used words that appear often in written texts.",
                details: "Common sight words help build reading comprehension and speed.",
                examples: [
                  "Example 1: it. 'It' is a common sight word used as a pronoun.",
                  "Example 2: you. 'You' is a common sight word used as a pronoun."
                ],
                problem: {
                  question: "Identify the sight words in the sentence: 'It was a sunny day.'",
                  solution: "The sight words are 'it,' 'was,' and 'a.'"
                }
              },
            
            
              "Reading Comprehension-Simple Stories": {
                definition: "Simple stories are short narratives with easy-to-understand language and pictures to enhance understanding.",
                details: "Simple stories often have a clear beginning, middle, and end, making them perfect for early readers.",
                examples: [
                  "Example 1: A short story about a cat and a dog becoming friends.",
                  "Example 2: A simple tale of a child planting a tree and watching it grow."
                ],
                problem: {
                  question: "What are the main elements of a simple story?",
                  solution: "The main elements of a simple story are a clear beginning, middle, and end, with easy-to-understand language and pictures."
                }
              },
              "Reading Comprehension-Picture Books": {
                definition: "Picture books are books with illustrations that tell a story.",
                details: "Picture books use a combination of images and text to convey a story, making them engaging for young readers.",
                examples: [
                  "Example 1: A book with colorful illustrations about a day at the zoo.",
                  "Example 2: A picture book showing the adventures of a superhero in a city."
                ],
                problem: {
                  question: "Why are picture books important for early readers?",
                  solution: "Picture books are important for early readers because they use images to support text, making the story more engaging and easier to understand."
                }
              },
            
            
              "Writing-Tracing Letters": {
                definition: "Tracing letters is a practice activity where children trace over printed letters to learn their shapes and forms.",
                details: "Tracing letters helps children develop fine motor skills and familiarity with the alphabet.",
                examples: [
                  "Example 1: A worksheet with dotted letters for children to trace over.",
                  "Example 2: An activity book where children trace each letter of the alphabet."
                ],
                problem: {
                  question: "What is the purpose of tracing letters?",
                  solution: "The purpose of tracing letters is to help children develop fine motor skills and familiarity with the alphabet."
                }
              },
              "Writing-Simple Sentences": {
                definition: "Simple sentences are short and straightforward sentences that use basic vocabulary.",
                details: "Writing simple sentences helps children practice sentence structure and improve their writing skills.",
                examples: [
                  "Example 1: The cat sits. This sentence uses basic vocabulary and a simple structure.",
                  "Example 2: I like apples. This sentence uses basic vocabulary and a simple structure."
                ],
                problem: {
                  question: "Write a simple sentence using the word 'dog'.",
                  solution: "The dog barks. This sentence uses basic vocabulary and a simple structure."
                }
              },
            
          
          
      
              
              
  

};

const English = () => {
  const [selectedTopic, setSelectedTopic] = useState("");

  const handleTopicChange = (e) => {
    setSelectedTopic(e.target.value);
  };

  const handleReadAloud = () => {
    const topic = topics[selectedTopic];
    const utterance = new SpeechSynthesisUtterance(topic.definition);
    const utterance1 = new SpeechSynthesisUtterance(topic.details);
    speechSynthesis.speak(utterance);
    speechSynthesis.speak(utterance1);

    topic.examples.forEach((example) => {
      const exampleUtterance = new SpeechSynthesisUtterance(example);
      speechSynthesis.speak(exampleUtterance);
    });

    if (topic.problem) {
      const questionUtterance = new SpeechSynthesisUtterance(topic.problem.question);
      speechSynthesis.speak(questionUtterance);
      const solutionUtterance = new SpeechSynthesisUtterance(topic.problem.solution);
      speechSynthesis.speak(solutionUtterance);
    }
  };

  return (
    <div className="container">
      <h1>English Basic Topics</h1>
      <select onChange={handleTopicChange} value={selectedTopic} className="topic-select">
        <option value="">Select Topic</option>
        {Object.keys(topics).map((topic, index) => (
          <option key={index} value={topic}>{topic}</option>
        ))}
      </select>
      {selectedTopic && (
        <div className="topic-details">
          <h2>{selectedTopic}</h2>
          <p>{topics[selectedTopic].definition}</p>
          <p>{topics[selectedTopic].details}</p>
          <ul>
            {topics[selectedTopic].examples.map((example, index) => (
              <li key={index}>{example}</li>
            ))}
          </ul>
          {topics[selectedTopic].problem && (
            <div>
              <p><strong>Problem:</strong> {topics[selectedTopic].problem.question}</p>
              <p><strong>Solution:</strong> {topics[selectedTopic].problem.solution}</p>
            </div>
          )}
          <button onClick={handleReadAloud}>Read Aloud</button>
        </div>
      )}
    </div>
  );
};

export default English;
